import { pluralize } from 'utils/string';
import { success } from 'components/core/Notification';

export default {
  subscriptionsUpdated: ({ frequency, itemsCount }) => (
    success(`Email frequency for your ${itemsCount} ${pluralize('subscription', 'subscriptions', itemsCount)} updated to '${frequency}'.`)
  ),
  subscriptionsDeleted: itemsCount => success(`Unsubscribed from ${itemsCount} ${pluralize('item', 'items', itemsCount)}`),
};
